// Tyler Mares' input filter plugin (with additional 'xss' filterType)
(function ($) {

	if ($.fn.inputFilter) {
		
		return;

	}

	$.fn.inputFilter = function (options) {

		// Helper functions
		// Validates single input against a pattern
		function filter (e, pattern, currentValue) {

			var event = e || window.event,
				key = event.keyCode || event.which;

			key = String.fromCharCode(key);
			if (!pattern.test(key)) {

				event.returnValue = false;
				if (event.preventDefault) {

					event.preventDefault();

				}

			}

		}

		// Cleans entire contents against a pattern
		function clean (str, pattern) {

			return (str.match(pattern) || []).join('');

		}

		return this.each(function () {

			var $this = $(this);
			// Allow only 1 instance per object
			if ($this.data('hasInputFilter')) {

				return this;

			}
			$this.data('hasInputFilter', true);

			var ffCmdKeys = [ 8, 9, 37, 38, 39, 40, 46 ], // For Firefox keypress: Backspace, Tab, Arrows, Delete
				filterType = 'integer', // Default config
				regexNonGlobal = new RegExp(), // RegExp object without global flag
				regexGlobal; // Same RegExp object but with global flag

			// Config using options
			// only 1 option, otherwise extend a default {} with options
			if (options && options.type) {

				filterType = options.type;

			} else if ($this.attr('data-input-filter')) {

				// Configure filter type from attribute data-input-filter
				filterType = $this.attr('data-input-filter');

			}

			// Filter for integer input; regex pattern must exclude global flag 'g'
			if (filterType == 'integer') {

				regexNonGlobal = /\d/;
				// Filter unsignedFloat2 is fixed to hundredths place
				// Filter mixedNumberFloat2 is a whole number and/or decimal fixed to hundreds place

			} else if (filterType == 'unsignedFloat2' || filterType == 'mixedNumberFloat2') {

				// Overwrite of clean() due to nature of input
				clean = function (str) {

					if (filterType == 'unsignedFloat2') {

						str = parseFloat(str).toFixed(2);

					} else if (filterType == 'mixedNumberFloat2') {

						// if ( parseInt(str) == parseFloat(str) ) {
						if (str.indexOf('.') == -1) {

							str = parseFloat(str);

						} else {

							str = parseFloat(str).toFixed(2);

						}

					}
					if (isNaN(str)) {

						str = '';

					}
					return '' + str;

				};

				// Overwrite of filter() due to nature of input
				filter = function (e, pattern, el) {

					pattern = /\d|\./;
					var event = e || window.event,
						key = event.keyCode || event.which;

					key = String.fromCharCode(key);

					// Floating point resolution
					var resolution = 2,
						// Current value of el
						currentValue = el.value,
						// Does the input already have a decimal?
						hasDecimal = !!(currentValue.split('.').length - 1),
						// The decimal value (warning: if no decimal, returns the whole value)
						decimal = currentValue.slice(currentValue.lastIndexOf('.') + 1),
						// Is the cursor after the decimal?
						cursorAfterDecimal = hasDecimal && el.selectionStart > currentValue.lastIndexOf('.'),
						// Is the cursor before the current value
						cursorBeforeValue = currentValue.length > el.selectionStart,
						// Is the cursor at the start of the field
						cursorAtStart = el.selectionStart == 0,
						// Does the cursor have a selection?
						hasSelection = el.selectionStart < el.selectionEnd,
						// The selected text
						selection = currentValue.slice(el.selectionStart, el.selectcionEnd),
						// Does the selection contain the '.'?
						hasSelectedDot = selection.indexOf('.') > -1,
						// Is the input a '0' preceding a number on the left of the decimal?
						isZeroBeforeWholeNumber =
							key == '0' && !hasSelection && cursorAtStart && cursorBeforeValue && currentValue[0] != '.';

					// Reject input on the following conditions
					if (
						!pattern.test(key) ||
						(key == '.' && hasDecimal) ||
						(decimal.length > resolution - 1 && cursorAfterDecimal) ||
						isZeroBeforeWholeNumber
					) {

						event.returnValue = false;
						if (event.preventDefault) {

							event.preventDefault();

						}

					}

				};

			} else if (filterType == 'xss') {

				regexNonGlobal = /[^<>]/;

			}
			// TODO: Define/handle other filter types

			// RegExp flags are readonly so we need to manually copy the existing flags (if any) and add the global flag
			regexGlobal = new RegExp(
				regexNonGlobal.source,
				'g' + ((regexNonGlobal.ignoreCase && 'i') || '') + ((regexNonGlobal.multiline && 'm') || '')
			);

			$this
				.on('keypress', function (e) {

					if (
						(filterType == 'unsignedFloat2' ||
							filterType == 'integer' ||
							filterType == 'mixedNumberFloat2') &&
						navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
						($.inArray(parseInt(e.keyCode), ffCmdKeys) > -1 || e.ctrlKey || e.altKey)
					) {

						return true;

					}

					if ((e.which == 13) & (e.target.tagName.toLowerCase() != 'textarea')) {

						this.value = clean(this.value, regexGlobal);

					} else {

						filter(e, regexNonGlobal, this);

					}

				})
				.on('paste', function (e) {

					var that = this;
					// Delay for value to populate with paste
					setTimeout(function () {

						that.value = clean(that.value, regexGlobal);

					}, 100);

				})
				.on('focus blur', function (e) {

					var cleaned = clean(this.value, regexGlobal);
					if (this.value != cleaned) {

						this.value = cleaned;

					}

				});

		});

	};

})(jQuery);
